import {
  createPlugin,
  createRoutableExtension,
} from "@backstage/core-plugin-api";
import { Entity } from "@backstage/catalog-model";
import {
  CODE_DISPLAY_METADATA,
  EFF_ENV_ANNOTATION,
  EFF_FF_ANNOTATION,
} from "./hooks";

import { rootRouteRef } from "./routes";

export const codeConcernsPlugin = createPlugin({
  id: "code-concerns",
  routes: {
    root: rootRouteRef,
  },
});

export const CodeDisplayPage = codeConcernsPlugin.provide(
  createRoutableExtension({
    name: "codeDisplayPage",
    component: () =>
      import("./components/CodeDisplayPage").then((m) => m.CodeDisplayPage),
    mountPoint: rootRouteRef,
  })
);

export const codeDisplayAvailable = (entity: Entity) =>
  Boolean(entity?.metadata?.[CODE_DISPLAY_METADATA]);

export const EnvPage = codeConcernsPlugin.provide(
  createRoutableExtension({
    name: "EnvPage",
    component: () => import("./components/EnvPage").then((m) => m.EnvPage),
    mountPoint: rootRouteRef,
  })
);

export const FeatureFlagPage = codeConcernsPlugin.provide(
  createRoutableExtension({
    name: "FeatureFlagPage",
    component: () =>
      import("./components/FeatureFlagPage").then((m) => m.FeatureFlagPage),
    mountPoint: rootRouteRef,
  })
);

export const envVarsAvailable = (entity: Entity) =>
  Boolean(entity?.metadata?.[EFF_ENV_ANNOTATION]);

export const featureFlagsAvailable = (entity: Entity) =>
  Boolean(entity?.metadata?.[EFF_FF_ANNOTATION]);
